module.exports = __webpack_public_path__ + "img/figure-14.ec01481f.png";